import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Single shared source for hero Top 5 + full leaderboard. Keeps last good standings on failure.
export function useLeaderboard() {
  const [state, setState] = useState({ status: 'loading', entries: [], meta: null, lastSuccessAt: null });
  const [retrying, setRetrying] = useState(false);
  const good = useRef(null);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/leaderboard`);
      const meta = { raceMonth: data.raceMonth, startDate: data.startDate, endDate: data.endDate, prizePool: data.prizePool };
      if (data.status === 'ok' || data.status === 'stale') {
        good.current = { entries: data.entries || [], meta, lastSuccessAt: data.lastSuccessAt };
        setState({ status: data.status, ...good.current });
      } else {
        setState(good.current ? { status: 'stale', ...good.current } : { status: 'unavailable', entries: [], meta, lastSuccessAt: null });
      }
    } catch (e) {
      setState((s) => (good.current ? { status: 'stale', ...good.current } : { ...s, status: 'unavailable' }));
    }
  }, []);

  const retry = useCallback(async () => {
    setRetrying(true);
    await load();
    setRetrying(false);
  }, [load]);

  useEffect(() => {
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, [load]);

  return { ...state, retry, retrying };
}

export async function fetchPreviousLeaderboard() {
  const { data } = await axios.get(`${API}/leaderboard/previous`);
  return data;
}
